import { createContext, useContext, useState, useCallback, useEffect } from "react";
import * as TableAreaHelper from "helpers/TableAreaHelper";
import ShopContext from "context/ShopContext";

const AreaTableContext = createContext();

export function AreaTableProvider({ children }) {
  const [areas, setAreas] = useState([]);
  const [tables, setTables] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { hasFullKotValidity } = useContext(ShopContext);

  const fetchAreasAndTables = useCallback(
    async (showLoader = false) => {
      try {
        if (!hasFullKotValidity) {
          setAreas([]);
          setTables([]);
          return;
        }
        if (showLoader) setIsLoading(true);

        const { areas, tables } = await TableAreaHelper.loadInitialAreasAndTables();

        setAreas(areas);
        setTables(tables);
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    },
    [hasFullKotValidity],
  );

  useEffect(() => {
    const hasCache = areas.length > 0 || tables.length > 0;
    fetchAreasAndTables(!hasCache);
  }, [fetchAreasAndTables, areas.length, tables.length]);

  return (
    <AreaTableContext.Provider value={{ areas, tables, isLoading, refreshData: fetchAreasAndTables }}>
      {children}
    </AreaTableContext.Provider>
  );
}

export default AreaTableContext;
